export default "__VITE_ASSET__2998d344__"